import { authFetch } from '../../auth/authFetch';
import { getApiBaseUrl } from '../../auth/api';
import type { ApiResponse } from '../organisation/organisationApiTypes';

export interface PayRunAuditEvent {
  eventId: string; sequenceOrder: number; occurredAtUtc: string; category: string; eventType: string; outcome: string;
  summary: string; detail?: string; comment?: string; actorDisplayName: string; actorRoleLabels: string;
  workEntityId?: string; workEntityDisplayName?: string;
}
export interface PayRunAuditEmployeeOption { workEntityId: string; displayName: string }
export interface PayRunAuditPage {
  items: PayRunAuditEvent[]; totalCount: number; nextCursor?: string; employees: PayRunAuditEmployeeOption[];
  coverage: { includesBackfill: boolean; description: string };
}
export interface PayRunAuditFilters {
  search?: string; from?: string; to?: string; workEntityId?: string; category?: string;
  eventType?: string; outcome?: string; pageSize?: number; cursor?: string;
}
export class PayRunAuditApiError extends Error {
  constructor(public readonly status: number, message: string) { super(message); }
}
export const getPayRunAuditEvents = async (
  businessRecordId: string, payId: string, filters: PayRunAuditFilters, signal?: AbortSignal,
): Promise<PayRunAuditPage> => {
  const query = new URLSearchParams({ pageSize: String(filters.pageSize ?? 50) });
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== '') query.set(key, String(value));
  });
  const response = await authFetch(
    `${getApiBaseUrl()}/api/business-records/${encodeURIComponent(businessRecordId)}/payrun/${encodeURIComponent(payId)}/audit-events?${query}`,
    { signal },
  );
  const body = await response.json() as ApiResponse<PayRunAuditPage> & { title?: string };
  if (!response.ok || !body.result) throw new PayRunAuditApiError(response.status, body.message ?? body.title ?? 'Audit trail could not be loaded.');
  return body.result;
};
